exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".profile__letter-char-2TERQ4{display:block;text-align:center;text-transform:uppercase;font-size:23px;color:#fff;border-radius:50%;float:left;margin-right:10px}", ""]);
